"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ArrowDownSolidIcon = _interopRequireDefault(require("@8x8/oxygen-icon/icons/ArrowDownSolidIcon"));

var _ArrowUpSolidIcon = _interopRequireDefault(require("@8x8/oxygen-icon/icons/ArrowUpSolidIcon"));

var _oxygenConfig = require("@8x8/oxygen-config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DropdownIndicator = function DropdownIndicator(_ref) {
  var selectProps = _ref.selectProps,
      isDisabled = _ref.isDisabled,
      rest = _objectWithoutProperties(_ref, ["selectProps", "isDisabled"]);

  var menuIsOpen = selectProps.menuIsOpen,
      testId = selectProps.testId;
  var getStyles = rest.getStyles;

  var _getStyles = getStyles('dropdownIndicator', rest),
      color = _getStyles.color;

  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.DropdownIndicator, rest, !menuIsOpen ? /*#__PURE__*/_react["default"].createElement(_ArrowDownSolidIcon["default"], _extends({
    disabled: isDisabled,
    color: color
  }, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_ARROW_DOWN_SOLID_ICON")))) : /*#__PURE__*/_react["default"].createElement(_ArrowUpSolidIcon["default"], _extends({
    disabled: isDisabled,
    color: color
  }, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_ARROW_UP_SOLID_ICON")))));
};

DropdownIndicator.propTypes = {
  isDisabled: _propTypes["default"].bool,
  selectProps: _propTypes["default"].object
};
DropdownIndicator.defaultProps = {
  isDisabled: false,
  selectProps: undefined
};
var _default = DropdownIndicator;
exports["default"] = _default;